module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/core-js/internals/is-object.js
// module id = FL90
// module chunks = 0